import { app, translate } from "../app"
import { Container } from "./container"
import { languages } from "../locale"
import { shiftHexColorDown } from "../helpers"
import { SplitText } from "./splittext"

export function BlockRichText(props: { block: BlockRichText }) {
  const isRTL = languages[app.locale]?.rtl

  const { block } = props

  return <div style={{ border: `1px solid rgb(238, 238, 238)`}}>
    <Container block={block}>
      <div className={`fade-up-0 leading-relaxed !m-0 ${isRTL ? 'text-right' : 'text-left'}`} style={{ direction: isRTL ? "rtl" : "ltr", textAlign: isRTL ? "right" : "left" }}>
        <h1><SplitText text={translate(block.title)} /></h1>
        <div dangerouslySetInnerHTML={{ __html: translate(props.block.text) }}></div>
      </div>
    </Container>
  </div>

}